import { useMemo } from 'react';

import { useSearchCardsContext } from 'contexts/searchCards';
import { VIRTUAL_TOGGLE_FILTERS } from 'lib/filters';

const { championFilter, challengerFilter, contenderFilter } =
  VIRTUAL_TOGGLE_FILTERS;

export const useEarlyAccessRefinement = () => {
  const {
    challengerFilter: challengerFilterCurrentRefinement,
    contenderFilter: contenderFilterCurrentRefinement,
    championFilter: championFilterCurrentRefinement,
  } = useSearchCardsContext();

  const enabledEarlyAccess = useMemo(() => {
    if (championFilterCurrentRefinement) return championFilter;
    if (challengerFilterCurrentRefinement) return challengerFilter;
    if (contenderFilterCurrentRefinement) return contenderFilter;
    return null;
  }, [
    championFilterCurrentRefinement,
    challengerFilterCurrentRefinement,
    contenderFilterCurrentRefinement,
  ]);

  return {
    championFilterCurrentRefinement,
    challengerFilterCurrentRefinement,
    contenderFilterCurrentRefinement,
    enabledEarlyAccess,
  };
};
